webpackJsonp([213720915766396],{

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(17);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _gatsbyImage = __webpack_require__(48);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _lodash = __webpack_require__(24);
	
	var _Contents = __webpack_require__(18);
	
	var _ReadMoreButton = __webpack_require__(36);
	
	var _ReadMoreButton2 = _interopRequireDefault(_ReadMoreButton);
	
	var _ResponsiveGrid = __webpack_require__(15);
	
	__webpack_require__(271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderProjectImage = function renderProjectImage(props) {
		return (0, _lodash.get)(props.project, 'image.resolutions', null) !== null ? _react2.default.createElement(
			_ResponsiveGrid.Cell,
			{ colSpanDesktop: '2', colSpanTablet: '2', colSpanMobile: '4', key: 'image' },
			_react2.default.createElement(
				_Link2.default,
				{ to: props.project.link },
				_react2.default.createElement(_gatsbyImage2.default, { resolutions: (0, _lodash.get)(props.project, 'image.resolutions') })
			)
		) : null;
	};
	
	var renderProjectText = function renderProjectText(props) {
		return _react2.default.createElement(
			_ResponsiveGrid.Cell,
			{ colSpanDesktop: '4', colSpanTablet: '2', colSpanMobile: '4', withPadding: true, key: 'text' },
			_react2.default.createElement(
				_Link2.default,
				{ to: props.project.link },
				_react2.default.createElement(
					'h3',
					null,
					props.project.title
				)
			),
			_react2.default.createElement(_Contents.Paragraph, { text: (0, _lodash.get)(props.project, 'childContentfulProjectContentTextNode.childMarkdownRemark.html', null) }),
			!(0, _lodash.isEmpty)(props.project.link) && _react2.default.createElement(
				_ReadMoreButton2.default,
				{ to: props.project.link },
				'En savoir plus !'
			)
		);
	};
	
	var ProjectExcerpt = function ProjectExcerpt(props) {
		return _react2.default.createElement(
			_ResponsiveGrid.ResponsiveContainer,
			{ className: 'Atrakeur-ProjectExcerpt', white: true, withMarginHor: !props.disableMarginHor, withMarginVer: !props.disableMarginVer, key: props.key },
			'inverted' in props && props.inverted ? [renderProjectText(props), renderProjectImage(props)] : [renderProjectImage(props), renderProjectText(props)]
		);
	};
	
	exports.default = ProjectExcerpt;
	module.exports = exports['default'];

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(17);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(28);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _lodash = __webpack_require__(24);
	
	var _ResponsiveGrid = __webpack_require__(15);
	
	var _index = __webpack_require__(35);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _Contents = __webpack_require__(18);
	
	var _CardImage = __webpack_require__(60);
	
	var _CardImage2 = _interopRequireDefault(_CardImage);
	
	var _CardText = __webpack_require__(84);
	
	var _CardText2 = _interopRequireDefault(_CardText);
	
	var _ProjectExcerpt = __webpack_require__(213);
	
	var _ProjectExcerpt2 = _interopRequireDefault(_ProjectExcerpt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectsPage = function ProjectsPage(props) {
	  return _react2.default.createElement(
	    _gatsbyPluginPageTransitions2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'Atrakeur-Page' },
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement('meta', { charSet: 'utf-8' }),
	        _react2.default.createElement(
	          'title',
	          null,
	          'DIY, Mod\uFFFDlisme et Web / Blog'
	        )
	      ),
	      _react2.default.createElement(_index2.default, {
	        contentID: 'projects_title',
	        size: 'xlarge' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'Atrakeur-Content' },
	        (0, _lodash.map)(props.data.allContentfulProject.edges, function (_ref, index) {
	          var project = _ref.node;
	          return _react2.default.createElement(_ProjectExcerpt2.default, { project: project, inverted: index % 2 == 1, key: project.id });
	        })
	      )
	    )
	  );
	};
	
	exports.default = ProjectsPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-b0713135125d937ab7d1.js